<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('admin-playlist')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">New Playlist</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <div class="mb-4">
          <p class="input-title text-black">Title</p>
          <base-input
            alternative
            class="mb-3"
            name="Title"
            :rules="{ required: true }"
            placeholder="Title"
            v-model="title"
            
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Description</p>
          <base-input
            alternative
            class="mb-3"
            name="Description"
            :rules="{ required: true }"
            placeholder="Description"
            v-model="body"
          >
          </base-input>
        </div>

        <div class="mb-4">
          <p class="input-title text-black">Category</p>
          <b-form-select
            v-model="category"
            placeholder="Select"
            class="w-full"
            required
          >
            <b-form-select-option
              v-for="item in getAllCategory.result"
              class="py-5"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            >
            </b-form-select-option>
          </b-form-select>
        </div>

        <!-- <div v-for="(item, index) in episodes" :key="index" class="flex gap-3">
          <b-form-group label="" class="mb-3">
            <p class="font-semibold text-sm">Title</p>
            <base-input
              class="mb-3"
              v-model="item.title"
              placeholder="Enter episode title"
              name="Title"
              :rules="{
                required: true,
              }"
            ></base-input>
          </b-form-group>
          <b-form-group label="" class="mb-3 w-72">
            <p class="font-semibold text-sm">Video URL</p>
            <base-input
              class="mb-3"
              v-model="item.video_url"
              placeholder="Enter URL"
              name="Video URL"
              :rules="{
                required: true,
              }"
            ></base-input>
          </b-form-group>
          <div class="py-5">
            <base-button
              outline
              type="primary"
              class="px-2"
              @click.stop="removeField(index)"
              >Remove</base-button
            >
          </div>
        </div> 
        <div class="">
          <base-button outline type="primary" @click.stop="addField()"
            >Add Episode</base-button
          >
        </div>-->

        <base-button
          type="primary"
          outline
          class="w-full my-2 py-1"
          native-type="submit"
          >Create</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "./components/FileUploader.vue";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import _ from "lodash";
import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      episodes: [],
      title: "",
      category: "",
      body: "",
      editorOption: {
        theme: "snow",
      },
    };
  },
  computed: {
    ...mapState("playlist", { getAllCategory: "getAllCategory" }),
  },
  methods: {
    removeField(index) {
      this.episodes.splice(index, 1);
    },
    addField() {
      this.episodes.push({ title: "", video_url: "" });
    },
    async onSubmit() {
      let payload = {
        name: this.title,
        description: this.body,
        categoryId: this.category,
      };
      let loader = this.$loading();

      try {
        const blogdata = await this.$store.dispatch(
          "playlist/add_playlist",
          payload
        );
        // if (blogdata.code == 200) {
        this.$router.push({ name: "admin-playlist" });
        this.$swal.fire({
          title: "Congratulations!",
          text: "Your playlist has been successfully added to the website",
          icon: "success",
          confirmButtonText: "Okay",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        // }
        loader.close();
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.addField();
  },
};
</script>
